import React from "react";
import PropTypes from "prop-types";

import { Label } from "semantic-ui-react";

function HubName({ name, hubId }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5em",
      }}
      data-test="hub-name"
    >
      {name}
      {hubId && <Label data-test="hub-id">{hubId}</Label>}
    </div>
  );
}

HubName.propTypes = {
  name: PropTypes.string.isRequired,
  hubId: PropTypes.string,
};

HubName.defaultProps = { hubId: undefined };

export default HubName;
